import React from "react";
import { Link } from "react-router-dom";

const Icon = ({ d, d2 }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
    {d2 && <path d={d2} />}
  </svg>
);

const PRODUCTS = [
  {
    iconD: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    title: "DXchange — API Management",
    desc: "Enterprise Data Exchange platform enabling seamless integration among cloud and on-premise applications across Insurance, Banking, Travel, Healthcare and Legal.",
    href: "/dxchange",
  },
  {
    iconD: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8",
    title: "Travel & Hospitality Platform",
    desc: "End-to-end online solutions including Central Reservation Systems, back-office ERP, inventory management, API integration, channel management and booking engines.",
    href: "/travel-hospitality",
  },
  {
    iconD: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
    title: "Healthcare Solutions",
    desc: "Hospital information systems, EMR, patient management, pharmacy and lab systems, revenue cycle management and telehealth platforms for enterprise healthcare organizations.",
    href: "/healthcare",
  },
  {
    iconD: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
    title: "Insurance Solutions",
    desc: "Policy administration, claims management, compliance platforms, enterprise data exchange and Marketing Automation workflows for insurance companies.",
    href: "/insurance",
  },
  {
    iconD: "M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3",
    title: "Legal Solutions",
    desc: "Case management, document management, e-discovery, contract lifecycle management and legal content management systems built for enterprise law firms and legal departments.",
    href: "/legal",
  },
  {
    iconD: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z",
    iconD2: "M15 12a3 3 0 11-6 0 3 3 0 016 0z",
    title: "BizRuleEngine — BRMS",
    desc: "Business Rules Management System for dynamic, configurable business logic — enabling non-technical users to manage complex enterprise rules without code changes.",
    href: "/biz-rule-engine",
  },
  {
    iconD: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
    title: "Content Management System",
    desc: "Customized Content Management System built for enterprise organizations requiring scalable, configurable publishing workflows and multi-channel content delivery.",
    href: "/cms",
  },
  {
    iconD: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z",
    iconD2: "M15 11a3 3 0 11-6 0 3 3 0 016 0z",
    title: "Umrah Booking Solution",
    desc: "Off-the-shelf booking solution for pilgrims and B2B agents to book Umrah packages, flights, hotels and ground services — integrated with major GDS and supplier APIs.",
    href: "/umrah-booking-solution",
  },
];

const NewProducts = () => (
  <section className="products-v2" aria-labelledby="products-heading" id="products">
    <div className="container">
      <p className="section-eyebrow">Our Products</p>
      <h2 id="products-heading" className="section-title">
        Off-the-shelf enterprise platforms. Ready to deploy.
      </h2>
      <p className="section-sub">
        Proprietary platforms and accelerators built over 30+ years of enterprise software engineering —
        customizable, modular and configurable for your industry vertical. Each platform
        has been deployed, client-accepted and proven in production.
      </p>

      <div className="row">
        {PRODUCTS.map(({ iconD, iconD2, title, desc, href }) => (
          <div key={href} className="col-lg-3 col-md-6 mb-4">
            <Link to={href} className="product-card d-block text-decoration-none">
              <div className="product-card-icon-wrap" aria-hidden="true">
                <Icon d={iconD} d2={iconD2} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </Link>
          </div>
        ))}
      </div>

      <div className="text-center mt-2">
        <Link
          to="/more-products"
          className="hero-v2-btn-primary"
          style={{ display: "inline-block" }}
        >
          View All Products →
        </Link>
      </div>
    </div>
  </section>
);

export default NewProducts;
